module.exports = __webpack_public_path__ + "7ccb55d9d824551a3d2a3079d3bca797.jpg";